import React from 'react';

const DEFAULT_SUBSCRIPTION_PORTAL_URL =
    process.env.REACT_APP_REPORT_SUBSCRIPTIONS_FORM_URL ||
    '';

const subscriptionPortals = [
    {
        name: 'BDX Self-Service Portal',
        description: 'Subscribe or manage BDX-related report subscriptions.',
        url: DEFAULT_SUBSCRIPTION_PORTAL_URL,
    },
];

export default function ReportSubscriptions() {
    const configuredPortals = subscriptionPortals.filter((portal) => Boolean(portal.url));
    const missingPortals = subscriptionPortals.filter((portal) => !portal.url);

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Report Subscriptions</h1>
                <p className="text-gray-600">Select a portal below to subscribe, amend, or cancel report subscriptions.</p>
            </div>

            {configuredPortals.length === 0 && (
                <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-lg p-4 text-sm">
                    No subscription links are configured. Add one or more report subscription URLs in your environment settings.
                </div>
            )}

            {configuredPortals.length > 0 && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {configuredPortals.map((portal) => (
                        <div key={portal.name} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col">
                            <h2 className="text-lg font-semibold text-gray-900 mb-2">{portal.name}</h2>
                            <p className="text-sm text-gray-600 mb-5">{portal.description}</p>
                            <a
                                href={portal.url}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-orange-600 text-white font-medium hover:bg-orange-700 transition-colors mt-auto"
                            >
                                Open Portal
                            </a>
                        </div>
                    ))}
                </div>
            )}

            {missingPortals.length > 0 && (
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm text-slate-700">
                    Additional subscription portals can be enabled by setting environment variables:
                    <div className="mt-2 font-medium">
                        REACT_APP_REPORT_SUBSCRIPTIONS_CLAIMS_URL, REACT_APP_REPORT_SUBSCRIPTIONS_FINANCE_URL
                    </div>
                </div>
            )}
        </div>
    );
}
